module.exports = __webpack_public_path__ + "static/media/darknessZone.bbdb87eb.png";